import EndPointConfig from "../../models/api/endPointConfig";

const controller = "academyconfiguration";

/// Define all EndPoints for Reset Password contact.
export const AcademyConfigurationEP: EndPointConfig[] = [
    // Obtiene el listado de agentes con los parametros de busquda que se apliquen
    new EndPointConfig().setMethod("GET").setController(controller).setAlias("GetAcademyConfiguration"),

    new EndPointConfig().setMethod("POST").setController(controller).setAlias("CreateAcademyConfiguration"),

    new EndPointConfig().setMethod("PUT").setController(controller).setPattern("{id}").setAlias("UpdateAcademyConfiguration"),

    new EndPointConfig().setMethod("PUT").setController(controller).setActionName('orders').setAlias("UpdateAcademyConfigurationOrder"),

    new EndPointConfig().setMethod("DELETE").setController(controller).setPattern("{id}").setAlias("DeleteAcademyConfiguration"),

    new EndPointConfig().setMethod("PATCH").setController(controller).setPattern("{id}/ChangeAcademyConfigurationStatus/{status}").setAlias("ChangeAcademyConfigurationStatus"),

    new EndPointConfig().setMethod("GET").setController(controller).setActionName('config').setAlias("GetAcademyConfig"),

    new EndPointConfig().setMethod("PATCH").setController(controller).setActionName('config').setAlias("ChangeAcademyConfiguration")

];